import { uniqBy } from "lodash";

export function numberFormat(val: number | undefined) {
  if (typeof val === "number") {
    return val.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else {
    return val;
  }
}

export function formatCompactNumber(number: number | undefined) {
  if (typeof number === "number") {
    if (number < 1000) {
      return number;
    } else if (number >= 1000 && number < 1_000_000) {
      return (number / 1000).toFixed(1).replace(/\.0$/, "") + "K";
    } else if (number >= 1_000_000 && number < 1_000_000_000) {
      return (number / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
    } else if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
      return (number / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
    } else if (number >= 1_000_000_000_000 && number < 1_000_000_000_000_000) {
      return (number / 1_000_000_000_000).toFixed(1).replace(/\.0$/, "") + "T";
    }
  } else {
    return number || "";
  }
}

export function getCsvContent<T>(file: File, keys: (keyof T)[]): Promise<T[]> {
  return new Promise<any>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file, "UTF-8");
    reader.onload = function (e: any) {
      const content = String(e.target.result);
      if (content) {
        const members = content
          .split("\n")
          .map((i) => i.replace("\r", ""))
          .filter((i, k) => i && k > 0);
        if (members.length > 0) {
          resolve(
            members.map((a) => {
              const items = a.split(",");
              const obj: any = {};
              keys.forEach((k, i) => {
                obj[k] = items[i] || "";
              });
              return obj;
            }),
          );
        } else {
          reject("Invalid CSV file, file is empty.");
        }
      }
    };
    reader.onerror = function (e) {
      reject(e);
    };
  });
}

export const emailPattern =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
